import {
  getSuggestion,
  initExternalModule,
  loadDevConfig,
  resetChat,
  resetConfig,
  sendNewMessage,
  showCrossSale,
  toggleAppChat,
  toggleCart,
  toggleTooltip,
  updateAppParams,
  updateProductList,
  updateSession,
} from '@/utils';

const sayWhattChat = {
  init: initExternalModule('app'),
  toggleChat: toggleAppChat,
  updateParams: updateAppParams,
  toggleCart: toggleCart,
  updateSession: updateSession,
  sendNewMessage: sendNewMessage,
  resetConfig: resetConfig,
  toggleTooltip: toggleTooltip,
  updateProductList: updateProductList,
  getSuggestion: getSuggestion,
  resetChat: resetChat,
  showCrossSale: showCrossSale,
};

window.sayWhattChat = sayWhattChat;

if (import.meta.env.DEV && window.configUrl) {
  const scriptId = 'devConfig';
  loadDevConfig(scriptId, window.configUrl)
    .then(() => {
      window.dispatchEvent(new Event('load'));
      document.getElementById(scriptId)?.remove();
    })
    .catch((error) => {
      console.error(error);
    });
}

export default sayWhattChat;
